import React from 'react';
import { Button } from '../ui/button';
import { ArrowRight, Award, BadgePercent, Shirt, MousePointerClick } from 'lucide-react';

const BenefitsSection = () => {
  const benefits = [
    {
      icon: Award,
      title: "Moda de marca",
      description: "Prendas seleccionadas de firmas reconocidas."
    },
    {
      icon: BadgePercent,
      title: "Precio outlet",
      description: "Calidad premium a precios mucho más accesibles."
    },
    {
      icon: Shirt,
      title: "Estilo versátil",
      description: "Ropa pensada para oficina, ocio o eventos."
    },
    {
      icon: MousePointerClick,
      title: "Compra online fácil",
      description: "Encuentra tu look perfecto en pocos clics."
    }
  ];

  return (
    <section data-testid="benefits-section" className="section-padding bg-[#111111]">
      <div className="container-custom">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="text-sm font-sans tracking-[0.2em] uppercase text-[#C8A96A] mb-4 block">
            Ventajas Exclusivas
          </span>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-white">
            Por qué comprar en StyleOutlet
          </h2>
        </div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {benefits.map((benefit, index) => (
            <div 
              key={index}
              data-testid={`benefit-${index}`}
              className="text-center group"
            >
              {/* Icon */}
              <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-[#C8A96A] flex items-center justify-center transform group-hover:scale-110 transition-transform duration-300">
                <benefit.icon className="w-10 h-10 text-white" strokeWidth={1.5} />
              </div>

              {/* Title */}
              <h3 className="font-serif text-xl text-white mb-3">
                {benefit.title}
              </h3>

              {/* Description */}
              <p className="font-sans text-white/70 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <a 
            href="https://styleoutlet.es" 
            target="_blank" 
            rel="noopener noreferrer"
            data-testid="benefits-cta"
          >
            <Button className="bg-[#C8A96A] hover:bg-white hover:text-[#111111] text-white px-10 py-6 text-base font-bold tracking-widest uppercase transition-all duration-300 cursor-pointer">
              Ver catálogo completo
              <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
